import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { Questions, Rules } from 'src/app/common-class/questions';
import { Answers } from 'src/app/common-class/answers';


import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { Group } from 'src/app/common-class/pages';
import { PreviewData } from 'src/app/common-class/survey';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.css'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadioButtonComponent implements OnInit, OnChanges {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isDisplaySubQno: boolean;
  @Input() isMobile: boolean;
  @Input() group: Group;
  @Input() isGrid: boolean;
  @Input() radiolength: number;
  @Input() isNewParticipationButton: boolean;
  @Input() isStandAlone: boolean;

  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() ChangeLoadingAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions;
  qdlQuestions: Questions[] = [];
  answerImagesLength: number;

  columnWidth: any;

  tempArray = [];
  answersArray: any;
  singleImageArray: Array<number> = [];
  multiImageArray: Array<number> = [];
  inLineRuleArray: Array<string> = [];
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  isPreview: boolean;
  isAriaRequired: boolean;
  isCapchaManditorySkip: boolean;
  nextButtonClickNo: number;
  pageIsSoftRequiredHandle: any = false;
  nextButtonClickSub: any;
  isNewParticipation: any;
  surveyFormat: number;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  isAnsChange: boolean;
  isOtherQuestion: boolean = false;
  resetPageSub: any;
  isDisplayedPipeMessage: boolean;
  isQDLNewParticipationButton: boolean = false;
  AsteriskMandatory: string = '';
  preview: PreviewData;
  isEditPostPop: boolean = false;

  // Add property to store event listener references
  private eventListeners: Map<string, (event: Event) => void> = new Map();

  setPreviewData(preview: PreviewData) {
    return (this.preview = preview);
  }
  ngOnChanges(changes: SimpleChanges) {
    let curVal;
    let preVal;
    let change = changes['JsonData'];

    if (change) {
      curVal = JSON.stringify(change.currentValue);
      preVal = JSON.stringify(change.previousValue);
    }

    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
      this.answerPipingMessageDisplayed();

      if (
        this.questions.answer_style == 1 &&
        this.questions.RotateIndex == 0 &&
        this.questions.Answers != null
      ) {
        this.RandomAnswerHandling();
      }
      this.inLineRuleArray.length = 0;
      if (this.questions.qsubtype == 0 || this.questions.qsubtype == 7) {
        if (this.questions.DispAnsCol > 1) {
          if (this.questions.DispAnsCol > 1 && this.questions.Answers != null) {
            this.HorizontalAndVerticalHandling();
          }
        }

        this.ngAfterViewInit();
      }

      if (this.questions.qsubtype == 1) {
        let id = 'div_Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_ID';
        const container = document.getElementById(id);

        if (container) {
          const radioButtons = container.querySelectorAll<HTMLInputElement>('input[type="radio"]');
          radioButtons.forEach(rb => rb.checked = false);
        }
        this.ngAfterViewInit();
      }
    }
  }

  constructor(
    private service: ParticipationDataService,
    private changeDetect: ChangeDetectorRef,
    private previewData: PreviewData,
  ) { }

  ngOnInit() {
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);

      this.isEditPostPop = this.service.getisEditPostPop();
      this.answerPipingMessageDisplayed();
      this.AsteriskMandatory = this.service.getSurveyMessages()?.AsteriskMandatory;
      let updateItem = this.questions?.Answers.find(
        (e) =>
          (e.hasImage && e.AnswerImages.length == 2) ||
          (e.hasMedia && e.AnswerMedias.length == 2) ||
          (e.hasImage && e.AnswerImages.length == 1 && e.hasMedia && e.AnswerMedias.length == 1),
      );

      if (this.questions?.Answers.filter((e) => e.isOther).length > 0) {
        this.isOtherQuestion = true;
      }
      if (this.questions?.population_type == 3) {
        this.isAnsChange = true;
      }
      if (updateItem != null && updateItem != undefined) {
        this.answerImagesLength = 2;

        if (this.questions?.population_type == 3) {
          if (this.questions.selectAnsValue != updateItem.value_id) {
            this.answerImagesLength = 0;
          }
        }
      } else {
        updateItem = this.questions?.Answers.find(
          (e) =>
            (e.hasImage && e.AnswerImages.length == 1) ||
            (e.hasMedia && e.AnswerMedias.length == 1),
        );

        if (updateItem != null && updateItem != undefined) {
          this.answerImagesLength = 1;

          if (this.questions.population_type == 3) {
            if (this.questions.selectAnsValue != updateItem.value_id) {
              this.answerImagesLength = 0;
            }
          }
        }
      }

      let hiddenAnswers = this.questions?.Answers.filter(
        (e) => !e.isHide && !e.isQuotaHide
      );
      if (hiddenAnswers?.length > 0 && this.questions.qtype == 'R' && this.questions.qsubtype == 1) {
        this.questions.Answers = hiddenAnswers;
      }

      if (
        this.questions?.answer_style == 1 &&
        this.questions?.RotateIndex == 0 &&
        this.questions?.Answers != null
      ) {
        this.RandomAnswerHandling();
      }

      if (this.questions?.DispAnsCol > 1 && this.questions.Answers != null) {
        this.HorizontalAndVerticalHandling();
      }

      // Set ControlAns property for edit response scenario
      if (this.questions.selectAnsValue > 0) {
        this.questions.Answers.forEach(answer => {
          if (answer.value_id === this.questions.selectAnsValue) {
            answer.ControlAns = answer.value_text;
            answer.selectdId = 1;
          } else {
            answer.ControlAns = null;
            answer.selectdId = 0;
          }
        });
        
        // Trigger change detection to update the UI
        this.changeDetect.detectChanges();
      }
    }

    // Initialize isAriaRequired
    this.updateAriaRequired();

    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
      this.updateAriaRequired(); // Update when form is submitted
    });

    if (this.questions?.qtype == 'HR') {
      this.answerImagesLength = 0;
    }

    this.isPreview = this.service.GroupType?.toUpperCase() == 'PREVIEW';
    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    this.showNewParticipationButton =
      this.isNewParticipationButton &&
      (!this.service.isAutoScroll || this.questions.population_type == 3);
      
  }

  // Add a new method to update isAriaRequired
  private updateAriaRequired() {
    this.isAriaRequired =
      (this.questions?.mandatory && this.isMandatoryUpfront) ||
      (this.questions?.mandatory && this.isFormSubmit && this.questions?.isMandatoryInvalid);
  }

  ngAfterViewInit() {
   if (window.navigator.userAgent.indexOf('Chrome') !== -1) {
      const setAnswerParent = document.querySelector('.answerParent');
      if (setAnswerParent) {
        setAnswerParent.setAttribute('style', 'display: table; width: calc(100% + 1px);');
      }
    }


    const self = this;
    if (this.questions?.qsubtype == 1) {
      setTimeout(() => {
        let holderHeight = 0;
        let holderPadding = 0;

        const wrappers = document.querySelectorAll<HTMLElement>('.image-choice-wrapper');

        wrappers.forEach(wrapper => {
          const visibleHolder = Array.from(wrapper.querySelectorAll<HTMLElement>('.ic-image-holder'))
            .find(el => el.offsetParent !== null); // Only visible ones

          if (visibleHolder) {
            holderHeight = Math.max(holderHeight, visibleHolder.offsetWidth);
          }

          const holders = wrapper.querySelectorAll<HTMLElement>('.ic-image-holder');
          holders.forEach(holder => {
            if (holder.classList.contains('showReportValue')) {
              const visibleReport = Array.from(holder.querySelectorAll<HTMLElement>('.ic-report-value'))
                .find(el => el.offsetParent !== null); // Only visible ones
              if (visibleReport) {
                holderPadding = Math.max(holderPadding, visibleReport.offsetHeight);
              }
            }
          });
        });

        wrappers.forEach(wrapper => {
          const label = wrapper.querySelector<HTMLElement>('.ic-label');
          const holders = wrapper.querySelectorAll<HTMLElement>('.ic-image-holder');

          holders.forEach(holder => {
            if (label?.classList.contains('medium')) {
              holder.classList.add('medium');
            } else if (label?.classList.contains('small')) {
              holder.classList.add('small');
            } else {
              holder.classList.add('large');
            }

            if (holder.classList.contains('showReportValue')) {
              holder.style.paddingBottom = `${holderPadding}px`;
              const reportValue = holder.querySelector<HTMLElement>('.ic-report-value');
              if (reportValue) {
                reportValue.style.height = `${holderPadding}px`;
              }
            }

            holder.style.height = `${holderHeight}px`;
          });
        });
      }, 50);

      window.addEventListener('resize', () => {
        const holders = document.querySelectorAll<HTMLElement>('.ic-image-holder');
        holders.forEach(holder => {
          if (holder.offsetParent !== null) { // Check if visible
            holder.style.height = `${holder.offsetWidth}px`;
          }
        });
      })
    } else if (this.questions?.DispAnsCol > 1) {
      // Add a small delay to ensure DOM is ready
      setTimeout(() => {
        for (let i = 0; i < this.questions.Answers.length; i++) {
          const id = `td_Q${this.questions.qno}_${this.questions.UniqueNumber}_${this.questions.Answers[i].value_id}`;
          const element = document.getElementById(id);

          if (element) {
            // Remove existing event listener if it exists
            const existingListener = this.eventListeners.get(id);
            if (existingListener) {
              element.removeEventListener('click', existingListener);
            }

            // Create new event listener
            const newListener = (event: Event) => {
              event.stopPropagation();
              const target = event.currentTarget as HTMLElement;
              if (!target.classList.contains('hrb-disabled')) {
                this.clickEventHandle(this.questions.Answers[i]);
                this.nextQuestion(event.target);
              }
            };

            // Store the listener reference and add it
            this.eventListeners.set(id, newListener);
            element.addEventListener('click', newListener);
          }
        }
      }, 50);
    }

    this.isAriaRequired =
      (this.questions?.mandatory && this.isMandatoryUpfront) ||
      (this.questions?.mandatory && this.isFormSubmit && this.questions?.isMandatoryInvalid);

    this.isCapchaManditorySkip = this.service.getIsCapchaMandatorySkip();
    this.pageIsSoftRequiredHandle = this.service.getPageIsSoftRequiredHandle();
    this.nextButtonClickNo =
      this.service.getNextButtonClickNo() == undefined ? 0 : this.service.getNextButtonClickNo();
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.isFormSubmitSub) {
      this.isFormSubmitSub.unsubscribe();
    }
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
    
    // Clean up event listeners
    this.eventListeners.forEach((listener, id) => {
      const element = document.getElementById(id);
      if (element) {
        element.removeEventListener('click', listener);
      }
    });
    this.eventListeners.clear();
  }

  answerPipingMessageDisplayed() {
    if (
      this.previewData != undefined &&
      this.service.getPrevPgChnge() &&
      this.questions.AnsPipeCondition != 0 &&
      this.questions.AnsPipeCondition != 1 &&
      this.questions.AnsPipeCondition != 3 &&
      this.questions.AnsPipeCondition != 4
    ) {
      this.isDisplayedPipeMessage = true;
    } else {
      this.isDisplayedPipeMessage = false;
    }
  }

  SortValue(valueId: any, curVal, self) {
    let ans = self.questions.Answers.find((e) => e.value_id == valueId);

    if (ans != null && ans != undefined) {
      if (curVal) {
        ans.ControlAns = ans.value_text;
        this.SelectedValue(ans);
      } else {
        this.ClickEventHandling(ans);
      }
    }
  }

  RandomAnswerHandling() {
    let currentIndex = this.questions.Answers.length,
      temporaryValue,
      randomIndex;
    let updateItem = this.questions.Answers.find((e) => e.isOther);

    if (updateItem != undefined && updateItem != null) {
      currentIndex -= 1;
    }

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = this.questions.Answers[currentIndex];
      this.questions.Answers[currentIndex] = this.questions.Answers[randomIndex];
      this.questions.Answers[randomIndex] = temporaryValue;
    }
  }

  HorizontalAndVerticalHandling() {
    let DispAnsCol = this.questions.DispAnsCol;

    let qShowAnswers = this.questions.Answers.filter((e) => !e.isADLHide);

    let answerLength = qShowAnswers.length;

    let updateItem = qShowAnswers.find((e) => e.isOther);

    if (updateItem != undefined && updateItem != null) {
      answerLength -= 1;
    }
    let rowCount = Math.ceil(answerLength / DispAnsCol);

    this.columnWidth = 100 / DispAnsCol;

    if (this.questions.DispAnsFormat == 1) {
      //Vertical
      let ansArray = [];
      for (let i = 0; i < rowCount; i++) {
        let tempArray = [];
        let index = 0;
        for (let j = i; j < answerLength; j = j + rowCount) {
          tempArray.push(qShowAnswers[j]);

          if (qShowAnswers[j].hasImage) {
            this.SingleAndMultiImageHandling(index, j);
          }

          index++;
        }

        ansArray.push(tempArray);
      }
      if (updateItem != undefined && updateItem != null) {
        let tempArray = [];
        tempArray.push(updateItem);
        ansArray.push(tempArray);
      }
      this.answersArray = ansArray;
    } else if (this.questions.DispAnsFormat == 2 || this.questions.qtype == 'HR') {
      //Horizontal
      let ansArray = [];

      for (let i = 0; i < rowCount; i++) {
        let tempArray = [];
        let counter = 0;
        let index = 0;
        for (let j = i * DispAnsCol; j < answerLength; j++) {
          counter++;
          tempArray.push(qShowAnswers[j]);

          if (qShowAnswers[j].hasImage) {
            this.SingleAndMultiImageHandling(index, j);
          }
          index++;

          if (counter == DispAnsCol) {
            break;
          }
        }

        ansArray.push(tempArray);
      }
      if (updateItem != undefined && updateItem != null) {
        let tempArray = [];
        tempArray.push(updateItem);
        ansArray.push(tempArray);
      }
      this.answersArray = ansArray;
    }
  }

  SingleAndMultiImageHandling(index: number, j: number) {
    if (
      (this.questions.Answers[j].AnswerMedias != null &&
        this.questions.Answers[j].AnswerMedias.length > 1) ||
      (this.questions.Answers[j].AnswerImages != null &&
        this.questions.Answers[j].AnswerImages.length > 1) ||
      this.multiImageArray.indexOf(index) >= 0
    ) {
      if (this.multiImageArray.indexOf(index) < 0) {
        this.multiImageArray.push(index);
      }

      if (this.singleImageArray.indexOf(index) >= 0) {
        this.singleImageArray.splice(this.singleImageArray.indexOf(index), 1);
      }
    } else if (
      this.questions.Answers[j].AnswerMedias != null &&
      this.questions.Answers[j].AnswerMedias.length == 1 &&
      this.questions.Answers[j].AnswerImages != null &&
      this.questions.Answers[j].AnswerImages.length == 1
    ) {
      if (this.multiImageArray.indexOf(index) < 0) {
        this.multiImageArray.push(index);
      }

      if (this.singleImageArray.indexOf(index) >= 0) {
        this.singleImageArray.splice(this.singleImageArray.indexOf(index), 1);
      }
    } else {
      if (this.singleImageArray.indexOf(index) < 0) {
        this.singleImageArray.push(index);
      }
    }
  }

  HasSingleImageClass(index: number): boolean {
    if (this.singleImageArray.indexOf(index) >= 0) {
      return true;
    } else {
      return false;
    }
  }

  HasMultiImageClass(index: number): boolean {
    if (this.multiImageArray.indexOf(index) >= 0) {
      return true;
    } else {
      return false;
    }
  }

  GetMandatoryState(): boolean {
    if (this.questions != null) {
      return this.questions.mandatory;
    }
  }

  SelectedValue(answer: Answers) {
    if (this.questions != null) {
      for (let i = 0; i < this.questions.Answers.length; i++) {
        if (answer.ms_id === this.questions.Answers[i].ms_id) {
          answer.selectdId = 1;
          answer.ControlAns = answer.value_text;
          this.questions.Answers[i] = answer;
          this.questions.AnswerID = answer.ms_id;
          this.questions.selectAnsValue = answer.value_id;
          this.questions.AnswerText = answer.ControlAns;
          this.questions.pageto = answer.pageto;
          this.questions.otherAnswer = null;

          if (this.questions.isSoftRequired) {
            this.questions.isSoftRequiredHandle = true;
          }

          if (answer.isOther) {
            this.questions.isOtherAnswer = true;
          } else {
            this.questions.isOtherAnswer = false;
          }
        } else {
          this.questions.Answers[i].ControlAns = null;
          this.questions.Answers[i].selectdId = 0;
        }
      }
      if (this.isNewParticipation) {
        if (this.questions.rules != null) {
          this.CheckSelectdValueHaveInlineQDL();
        }
        this.changeDetect.detectChanges();
      }
      this.UpdateQuestionsData(this.questions);
    }
  }

  CheckSelectdValueHaveInlineQDL() {
    let rules = this.questions.rules.filter((e) => e.InlineQDL);

    if (rules != null && rules.length > 0) {
      for (let index = 0; index < rules.length; index++) {
        if (this.loadInlineQDL(rules[index].Rule_id) != null) {
          this.isQDLNewParticipationButton = true;
          break;
        } else {
          this.isQDLNewParticipationButton = false;
        }
      }
    }
  }

  ClickEventHandling(answer: Answers) {
    if (answer.selectdId == 0) {
      return;
    }
    if (this.questions != null) {
      answer.selectdId = 0;
      answer.ControlAns = null;
      let updateItem = this.questions.Answers.find(this.findIndexToUpdate, answer);
      let index = this.questions.Answers.indexOf(updateItem);
      this.questions.Answers[index] = answer;
      this.questions.AnswerID = 0;
      this.questions.selectAnsValue = 0;
      this.questions.pageto = 0;
      this.questions.AnswerText = null;
      this.questions.otherAnswer = null;
      this.questions.isOtherAnswer = false;
      if (this.isNewParticipation) {
        if (this.questions.rules != null) {
          this.CheckSelectdValueHaveInlineQDL();
        }
        this.changeDetect.detectChanges();
      }
      this.UpdateQuestionsData(this.questions);

      if (this.questions.isSoftRequired) {
        this.questions.isSoftRequiredHandle = false;
      }
    }
  }

  findIndexToUpdate(answer) {
    return answer === this;
  }

  GetQuestionsString(question: Questions, rule_id: number): string {
    return JSON.stringify(question);
  }

  UpdateQuestionsData(question: Questions) {
    if (this.questions.isOtherAnswer || this.showNewParticipationButton) {
      this.isAnsChange = true;
    }
    this.ChangeAnswersData.emit(question);
  }

  RatingScaleHeaderText(question: Questions, index: number, answer: Answers): string {
    if (answer.value_id == 1) {
      return this.group.L_text;
    } else if (this.group.M_Pos == parseInt(answer.value_text)) {
      return this.group.M_text;
    } else {
      let max = question.Answers.reduce((prev, current) =>
        prev.value_id > current.value_id ? prev : current,
      );
      if (max != null && max != undefined) {
        if (max.weight == 0) {
          if (answer.value_text == '') {
            return '';
          } else if (answer.value_text != null) {
            if (
              max.value_id - 1 == answer.value_id &&
              answer.weight != null &&
              answer.weight != 0
            ) {
              return this.group.H_text;
            } else if (answer.value_text != null && max.value_id == answer.value_id) {
              if (answer.value_text != null) {
                return answer.value_text;
              }
              return;
            }
          }
        } else if (max.value_id == answer.value_id && answer.weight != 0) {
          return this.group.H_text;
        }
        return;
      }
    }
  }

  getAnsImageMediaCSS(answer: Answers) {
    if (answer == undefined) {
      return '';
    }
    if (
      (answer.hasImage && answer.AnswerImages.length == 1 && !answer.hasMedia) ||
      (answer.hasMedia && answer.AnswerMedias.length == 1 && !answer.hasImage)
    ) {
      return 'single-ans-image';
    } else if (
      answer.hasImage &&
      answer.AnswerImages.length == 1 &&
      answer.hasMedia &&
      answer.AnswerMedias.length == 1
    ) {
      return 'multi-ans-image';
    } else if (
      (answer.hasImage && answer.AnswerImages.length == 2) ||
      (answer.hasMedia && answer.AnswerMedias.length == 2)
    ) {
      return 'multi-ans-image';
    } else {
      return '';
    }
  }

  onBlurMethod() {
    if (this.questions.AnswerText == '') {
      this.questions.AnswerText = null;
    }
    this.UpdateQuestionsData(this.questions);
  }

  loadInlineQDL(rule_Id: number): Questions {
    if (this.questions.rules != null && this.questions.rules.length > 0) {
      this.nextButtonClickNo = this.service.getNextButtonClickNo();
      let updateItem = this.questions.rules.filter((e) => e.Rule_id == rule_Id && e.InlineQDL);

      if (updateItem != null && updateItem != undefined) {
        return this.newInlineQDLHandling(updateItem);
      }
    }
  }
  checkifInlineisLoaded(answer: Answers): boolean {
    if (this.inLineRuleArray.indexOf(answer.Rule_id + '_' + answer.value_id) == -1) {
      this.inLineRuleArray.push(answer.Rule_id + '_' + answer.value_id);
      return true;
    } else {
      return false;
    }
  }
  newInlineQDLHandling(rule: Rules[]): Questions {
    for (let k = 0; k < rule.length; k++) {
      let value = rule[k].ConditionValue.split(',');

      if (value != undefined && value != null) {
        let count: number = 0;
        for (let i = 0; i < value.length; i++) {
          if (this.questions.selectAnsValue == parseInt(value[i])) {
            count++;
          }
        }
        if (this.newOperatorValid(rule[k], count, value) != null) {
          return this.newOperatorValid(rule[k], count, value);
        }
      }
    }
  }

  newOperatorValid(updateItem: Rules, count: number, value: any): Questions {
    if (
      updateItem.Operator == 'OR' &&
      count <= value.length &&
      count != 0 &&
      this.questions.AnswerText != null
    ) {
      return this.newLoadQDL(updateItem);
    } else if (updateItem.Operator == 'NOT' && count == 0) {
      return this.newLoadQDL(updateItem);
    } else if (updateItem.Operator == 'ISANSWERED' && this.questions.AnswerText != null) {
      return this.newLoadQDL(updateItem);
    } else if (updateItem.Operator == 'ISNOTANSWERED' && this.questions.AnswerText == null) {
      return this.newLoadQDL(updateItem);
    } else {
      return null;
    }
  }

  newLoadQDL(updateItem: Rules): Questions {
    let qn = this.service.GetQDL(updateItem.ConditionQID);

    if (qn != undefined && qn != null) {
      if (!qn.isLoading) {
        qn.isLoading = true;
        this.ChangeLoadingAnswersData.emit(qn);
      }
    }
    return this.service.GetQDL(updateItem.ConditionQID);
  }

  loadDestinationQn(rule_Id: number): Questions {
    if (
      this.questions.DestinationQuestions != null &&
      this.questions.DestinationQuestions != undefined
    ) {
      if (this.questions.DestinationQuestions.find((e) => e.rule_id == rule_Id) != undefined) {
        let qn = this.service.GetQDL(
          this.questions.DestinationQuestions.find((e) => e.rule_id == rule_Id).ConditionQID,
        );

        if (qn != undefined && qn != null) {
          if (!qn.isLoading) {
            qn.isLoading = true;
            this.ChangeLoadingAnswersData.emit(qn);
          }
        }

        return this.service.GetQDL(
          this.questions.DestinationQuestions.find((e) => e.rule_id == rule_Id).ConditionQID,
        );
      } else {
        return null;
      }
    }
  }

nextQuestion(event) {
    if (this.isNewParticipation && (this.surveyFormat == 1 ||  this.surveyFormat == 2) && (this.questions.ansConstraint == null || this.questions.isMatrixQuestion) && this.service.isAutoScroll && !this.isQDLNewParticipationButton) {
      let self = this;
    let scrollTargetElement = document.getElementById('bodyScroll') as HTMLElement;
      const checkIfPrevirew = this.service.preview && this.service.preview.viewport;
    
      setTimeout(() => {
        if (self.questions.selectAnsValue != 0) {
          if ((self.questions.qtype == "SR" || self.questions.qtype == "GR" || self.questions.qtype == "RG" || self.questions.qtype == "RW") ) {
              const activeQuestion = event.closest('.active-ques') as HTMLElement;
              const nextInactiveQuestions = Array.from(
                activeQuestion?.parentElement?.querySelectorAll('.inactive-ques') || []
              ).filter((el) => el.querySelector('.question-data'));
              const nextbtnLength = nextInactiveQuestions.length; 


               const activeQuestion1 = event.closest('.inactive-ques') as HTMLElement;
              const nextInactiveQuestions1 = Array.from(
                activeQuestion1?.parentElement?.querySelectorAll('.active-ques') || []
              ).filter((el) => el.querySelector('.question-data'));
              const nextbtnLength1 = nextInactiveQuestions1.length; 


             let elemPosition: number | null = null;
              const currentElementMtrx = event.closest('.matrix-standalone-active-ques' + self.questions.group_no) as HTMLElement;     
              if (currentElementMtrx) {
                const allSiblingsMtrx = Array.from(currentElementMtrx.parentElement?.children || []) as HTMLElement[];
                const nextElementsMtrx = allSiblingsMtrx
                  .slice(allSiblingsMtrx.indexOf(currentElementMtrx) + 1) 
                  .filter((sibling) => sibling.matches('.matrix-standalone-active-ques' + self.questions.group_no));     
                if (nextElementsMtrx.length > 0) {
                  elemPosition = nextElementsMtrx[0].getBoundingClientRect().top; 
                }
              }

              let MatrixelemPosition: number | null = null;
              let MatrixelemPosition1: number | null = null;


              if (this.questions.isMatrixQuestion != undefined) {
                // Handle `.matrix-mobile-subQ_`
                let matrixCurrentElementM = event.closest('.matrix-mobile-subQ_' + this.group.Matrix_id) as HTMLElement;
                if (matrixCurrentElementM) {
                  const allSiblingsM = Array.from(matrixCurrentElementM.parentElement?.children || []) as HTMLElement[];
                  const nextMatrixElementsM = allSiblingsM
                    .slice(allSiblingsM.indexOf(matrixCurrentElementM) + 1)
                    .filter((sibling) => sibling.matches('.matrix-mobile-subQ_' + this.group.Matrix_id));
                  if (nextMatrixElementsM.length > 0) {
                    MatrixelemPosition = nextMatrixElementsM[0].getBoundingClientRect().top;
                  }
                }

                  // Handle `.matrix-mobile-subQ-cont`
                  let matrixContCurrentElementM1 = event.closest('.matrix-mobile-subQ-cont') as HTMLElement;
                  if (matrixContCurrentElementM1) {
                    const allSiblingsM1 = Array.from(matrixContCurrentElementM1.parentElement?.children || []) as HTMLElement[];
                    const nextMatrixContElementsM1 = allSiblingsM1
                      .slice(allSiblingsM1.indexOf(matrixContCurrentElementM1) + 1)
                      .filter((sibling) => sibling.matches('.matrix-mobile-subQ-cont'));
                    if (nextMatrixContElementsM1.length > 0) {
                      MatrixelemPosition1 = nextMatrixContElementsM1[0].getBoundingClientRect().top;
                    }
                  } 
              }


              if (elemPosition) {
               let currentElementMSAQ = event.closest('.matrix-standalone-active-ques' + self.questions.group_no) as HTMLElement;
                if (currentElementMSAQ) {
                  const allSiblingsMSAQ = Array.from(currentElementMSAQ.parentElement?.children || []) as HTMLElement[];
                  const nextElementsMSAQ = allSiblingsMSAQ
                    .slice(allSiblingsMSAQ.indexOf(currentElementMSAQ) + 1) 
                    .filter((sibling) => sibling.matches('.matrix-standalone-active-ques' + self.questions.group_no));

                  const filteredElementsMSAQ = nextElementsMSAQ.filter((el) => el.querySelector('.question-data') !== null);

                  // Get the position of the first matching element
                  const firstMatchingElement = filteredElementsMSAQ[0];
                  if (firstMatchingElement) {
                    elemPosition = firstMatchingElement.getBoundingClientRect().top;
                  }
                }

                if(checkIfPrevirew && checkIfPrevirew != ''){
                  if(this.service.preview.viewport === "web"){
                      elemPosition =
                          elemPosition -
                          scrollTargetElement.getBoundingClientRect().top +
                          scrollTargetElement.scrollTop -
                          (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
                    }
                    else {
                      scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
                      elemPosition =
                          elemPosition -
                          scrollTargetElement.getBoundingClientRect().top +
                          scrollTargetElement.scrollTop;
                    }
                } else {
                      elemPosition =
                      elemPosition -
                      scrollTargetElement.getBoundingClientRect().top +
                      scrollTargetElement.scrollTop;
                  }
          
               scrollTargetElement.scrollTo({
                    top: elemPosition - window.innerHeight / 3,
                    behavior: 'smooth', 
                  });
              }else if (MatrixelemPosition) {
               let matrixCurrentElementMtrxELe = event.closest('.matrix-mobile-subQ_' + this.group.Matrix_id) as HTMLElement;
                  if (matrixCurrentElementMtrxELe) {
                    // Get all sibling elements after the current element
                    const allSiblingsMtrxEle = Array.from(matrixCurrentElementMtrxELe.parentElement?.children || []) as HTMLElement[];
                    const nextMatrixElementsMtrxEle = allSiblingsMtrxEle
                      .slice(allSiblingsMtrxEle.indexOf(matrixCurrentElementMtrxELe) + 1)
                      .filter((sibling) => sibling.matches('.matrix-mobile-subQ_' + this.group.Matrix_id) && sibling.querySelector('.question-data') !== null); // Filter by selector and `.question-data`

                    // Get the position of the first matching element
                    if (nextMatrixElementsMtrxEle.length > 0) {
                      MatrixelemPosition = nextMatrixElementsMtrxEle[0].getBoundingClientRect().top;
                    }
                  }
                if(checkIfPrevirew && checkIfPrevirew != ''){
                  if(this.service.preview.viewport === "web"){
                      MatrixelemPosition =
                          MatrixelemPosition -
                          scrollTargetElement.getBoundingClientRect().top +
                          scrollTargetElement.scrollTop -
                          (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
                    }
                    else {
                      scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
                      MatrixelemPosition =
                        MatrixelemPosition -
                        scrollTargetElement.getBoundingClientRect().top +
                        scrollTargetElement.scrollTop;
                    }
                  } else {
                    MatrixelemPosition =
                        MatrixelemPosition -
                        scrollTargetElement.getBoundingClientRect().top +
                        scrollTargetElement.scrollTop;
                  }
          
                  scrollTargetElement.scrollTo({
                    top: MatrixelemPosition - window.innerHeight / 3,
                    behavior: 'smooth',
                  });
              }else if (MatrixelemPosition1) {
               let matrixContCurrentElementM1 = event.closest('.matrix-mobile-subQ-cont') as HTMLElement;
                if (matrixContCurrentElementM1) {
                  // Get all sibling elements after the current element
                  const allSiblingsMtrxCOntM1 = Array.from(matrixContCurrentElementM1.parentElement?.children || []) as HTMLElement[];
                  const nextMatrixContElementsM1 = allSiblingsMtrxCOntM1
                    .slice(allSiblingsMtrxCOntM1.indexOf(matrixContCurrentElementM1) + 1) // Get all siblings after the current element
                    .filter((sibling) => sibling.matches('.matrix-mobile-subQ-cont') && sibling.querySelector('.question-data') !== null); // Filter by selector and `.question-data`

                  // Get the position of the first matching element
                  if (nextMatrixContElementsM1.length > 0) {
                    MatrixelemPosition1 = nextMatrixContElementsM1[0].getBoundingClientRect().top;
                  }
                }
                if(checkIfPrevirew && checkIfPrevirew != ''){
                    if(this.service.preview.viewport === "web"){
                    MatrixelemPosition1 =
                        MatrixelemPosition1 -
                        scrollTargetElement.getBoundingClientRect().top +
                        scrollTargetElement.scrollTop -
                        (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
                  }
                  else {
                    scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
                    MatrixelemPosition1 =
                      MatrixelemPosition1 -
                      scrollTargetElement.getBoundingClientRect().top +
                      scrollTargetElement.scrollTop;
                  }
                } else {
                  MatrixelemPosition1 =
                      MatrixelemPosition1 -
                      scrollTargetElement.getBoundingClientRect().top +
                      scrollTargetElement.scrollTop;
                }
                scrollTargetElement.scrollTo({
                  top: MatrixelemPosition1 - window.innerHeight / 3,
                  behavior: 'smooth',
                });
              } else if (nextbtnLength > 0) {
                  let activeQuestionForNBL = event.closest('.active-ques') as HTMLElement;


                 if (activeQuestionForNBL) {
                    // Get all sibling elements after the current element
                    const allSiblingsForNBL = Array.from(activeQuestionForNBL.parentElement?.children || []) as HTMLElement[];
                    const nextInactiveQuestionsForNBL = allSiblingsForNBL
                      .slice(allSiblingsForNBL.indexOf(activeQuestionForNBL) + 1) // Get all siblings after the current element
                      .filter((sibling) => sibling.matches('.inactive-ques') && sibling.querySelector('.question-data') !== null); // Filter by selector and `.question-data`
                  
                    // Get the position of the first matching element
                    if (nextInactiveQuestionsForNBL.length > 0) {
                      elemPosition = nextInactiveQuestionsForNBL[0].getBoundingClientRect().top;
                    }
                  }
                if(checkIfPrevirew && checkIfPrevirew != ''){
                  if(this.service.preview.viewport === "web"){
                      elemPosition =
                        elemPosition -
                        scrollTargetElement.getBoundingClientRect().top +
                        scrollTargetElement.scrollTop -
                        (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
                    }
                    else {
                      scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
                      elemPosition =
                        elemPosition -
                        scrollTargetElement.getBoundingClientRect().top +
                        scrollTargetElement.scrollTop;
                    }
                  } else {
                    elemPosition =
                      elemPosition -
                      scrollTargetElement.getBoundingClientRect().top +
                      scrollTargetElement.scrollTop;
                  }
                  scrollTargetElement.scrollTo({
                    top: elemPosition - window.innerHeight / 3,
                    behavior: 'smooth', // Replaces jQuery's animate for smooth scrolling
                  });
              }else if (nextbtnLength1 > 0) {
               let activeQuestionForNBLInactive = event.closest('.inactive-ques') as HTMLElement;


                 if (activeQuestionForNBLInactive) {
                    // Get all sibling elements after the current element
                    const allSiblingsForNBLNext = Array.from(activeQuestionForNBLInactive.parentElement?.children || []) as HTMLElement[];
                    const nextInactiveQuestionsForNBLInactive = allSiblingsForNBLNext
                      .slice(allSiblingsForNBLNext.indexOf(activeQuestionForNBLInactive) + 1) // Get all siblings after the current element
                      .filter((sibling) => sibling.matches('.active-ques') && sibling.querySelector('.question-data') !== null); // Filter by selector and `.question-data`
                  
                    // Get the position of the first matching element
                    if (nextInactiveQuestionsForNBLInactive.length > 0) {
                      elemPosition = nextInactiveQuestionsForNBLInactive[0].getBoundingClientRect().top;
                    }
                  }
                if(checkIfPrevirew && checkIfPrevirew != ''){
                  if(this.service.preview.viewport === "web"){
                      elemPosition =
                      elemPosition -
                      scrollTargetElement.getBoundingClientRect().top +
                      scrollTargetElement.scrollTop -
                      (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
                  }
                  else {
                  scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
                    elemPosition =
                      elemPosition -
                      scrollTargetElement.getBoundingClientRect().top +
                      scrollTargetElement.scrollTop;
                  }
                } else {
                elemPosition =
                  elemPosition -
                  scrollTargetElement.getBoundingClientRect().top +
                  scrollTargetElement.scrollTop;
                } 
                scrollTargetElement.scrollTo({
                  top: elemPosition - window.innerHeight / 3,
                  behavior: 'smooth', // Replaces jQuery's animate for smooth scrolling
                });
              }else{
                if(checkIfPrevirew && checkIfPrevirew != ''){
                  if(this.service.preview.viewport === "web"){
                    scrollTargetElement = document.getElementById('bodyScroll') as HTMLElement;
                  }
                  else {
                    scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
                  }
                } 
                const tblPageFooter = document.querySelector('.tblPageFooter') as HTMLElement;
                if (tblPageFooter && scrollTargetElement) {
                  const scrollVal =
                    tblPageFooter.getBoundingClientRect().top +
                    scrollTargetElement.scrollTop;

                    scrollTargetElement.scrollTo({
                      top: scrollVal,
                      behavior: 'smooth', 
                    });
                }
              }
          } else {
            if (!((((self.questions.qtype == "RW" || self.questions.qtype == "RG") && self.questions.qsubtype == 1) || ((self.questions.qtype == "GR"||self.questions.qtype == "SR") && self.questions.qsubtype == 0)) && self.radiolength > 1)) {


              this.service.gotoNextQuestion(this.questions,event);

            }
          }
        } else {
         const targetCpst = (event.targetCpst as HTMLElement).closest('.main-ques-cont');
          if (targetCpst) {
            const buttons = targetCpst.querySelectorAll('.ques-response-btn');
            buttons.forEach(btn => {
              (btn as HTMLElement).style.display = 'block';
            });
          }

        }
      }, 1);
    }
    else if (this.surveyFormat == 3) {
      const currElem = document.querySelector('.active-ques');

        if (currElem) {
          // Get all siblings after currElem with class 'inactive-ques'
          const allNextInactiveQues = Array.from(currElem.parentElement?.children || []).filter((el) => {
            return el.classList.contains('inactive-ques') && el.compareDocumentPosition(currElem) & Node.DOCUMENT_POSITION_FOLLOWING;
          });

          // Filter those that have a child with class 'question-data'
          const validNextElems = allNextInactiveQues.filter((el) => el.querySelector('.question-data'));

          const nextElem = validNextElems[0] as HTMLElement | undefined;
          const afterNextElem = validNextElems[1] as HTMLElement | undefined;

          if (nextElem) {
            // Remove 'disabled' class from all back arrows
            document.querySelectorAll('.back-arrow').forEach(el => el.classList.remove('disabled'));

            this.service.hideQuestion(currElem as HTMLElement);

            const isHidden = nextElem.querySelector('.question-data')?.hasAttribute('hidden');

            if (isHidden && afterNextElem) {
              this.service.showQuestion(afterNextElem);
            } else {
              this.service.showQuestion(nextElem);
            }
          } else{
            const nextButton = document.querySelector('.next-button') as HTMLElement | null;
              if (nextButton) {
                nextButton.click();
              }
          }
        }
    }
  }


   gotoNextQuestion(question: Questions, event: any) {
    if (this.isStandAlone) {
      // Get the number of next inactive questions with `.question-data`
      const activeQuestion = event.closest('.active-ques') as HTMLElement;
      const nextInactiveQuestions = Array.from(
        activeQuestion?.parentElement?.querySelectorAll('.inactive-ques') || []
      ).filter((el) => el.querySelector('.question-data'));
      const nextbtnLength = nextInactiveQuestions.length; 

      let scrollTargetElement = document.getElementById('bodyScroll') as HTMLElement; 
      const checkIfPreview = this.service.preview && this.service.preview.viewport;

      let elemPosition: number | null = null;
      const currentElementMtrx = event.closest('.matrix-standalone-active-ques' + question.group_no) as HTMLElement;     
      if (currentElementMtrx) {
        const allSiblingsMtrx = Array.from(currentElementMtrx.parentElement?.children || []) as HTMLElement[];
        const nextElementsMtrx = allSiblingsMtrx
          .slice(allSiblingsMtrx.indexOf(currentElementMtrx) + 1) 
          .filter((sibling) => sibling.matches('.matrix-standalone-active-ques' + question.group_no));     
        if (nextElementsMtrx.length > 0) {
          elemPosition = nextElementsMtrx[0].getBoundingClientRect().top; 
        }
      }
      let MatrixelemPosition: number | null = null;
      let MatrixelemPosition1: number | null = null;


      if (this.questions.isMatrixQuestion != undefined) {
        // Handle `.matrix-mobile-subQ_`
        let matrixCurrentElementM = event.closest('.matrix-mobile-subQ_' + this.group.Matrix_id) as HTMLElement;
        if (matrixCurrentElementM) {
          const allSiblingsM = Array.from(matrixCurrentElementM.parentElement?.children || []) as HTMLElement[];
          const nextMatrixElementsM = allSiblingsM
            .slice(allSiblingsM.indexOf(matrixCurrentElementM) + 1)
            .filter((sibling) => sibling.matches('.matrix-mobile-subQ_' + this.group.Matrix_id));
          if (nextMatrixElementsM.length > 0) {
            MatrixelemPosition = nextMatrixElementsM[0].getBoundingClientRect().top;
          }
        }

          // Handle `.matrix-mobile-subQ-cont`
          let matrixContCurrentElementM1 = event.closest('.matrix-mobile-subQ-cont') as HTMLElement;
          if (matrixContCurrentElementM1) {
            const allSiblingsM1 = Array.from(matrixContCurrentElementM1.parentElement?.children || []) as HTMLElement[];
            const nextMatrixContElementsM1 = allSiblingsM1
              .slice(allSiblingsM1.indexOf(matrixContCurrentElementM1) + 1)
              .filter((sibling) => sibling.matches('.matrix-mobile-subQ-cont'));
            if (nextMatrixContElementsM1.length > 0) {
              MatrixelemPosition1 = nextMatrixContElementsM1[0].getBoundingClientRect().top;
            }
          } 
      }

      if (elemPosition !== null) {
          let currentElementMSAQ = event.closest('.matrix-standalone-active-ques' + question.group_no) as HTMLElement;
          if (currentElementMSAQ) {
            const allSiblingsMSAQ = Array.from(currentElementMSAQ.parentElement?.children || []) as HTMLElement[];
            const nextElementsMSAQ = allSiblingsMSAQ
              .slice(allSiblingsMSAQ.indexOf(currentElementMSAQ) + 1) 
              .filter((sibling) => sibling.matches('.matrix-standalone-active-ques' + question.group_no));

            const filteredElementsMSAQ = nextElementsMSAQ.filter((el) => el.querySelector('.question-data') !== null);

            // Get the position of the first matching element
            const firstMatchingElement = filteredElementsMSAQ[0];
            if (firstMatchingElement) {
              elemPosition = firstMatchingElement.getBoundingClientRect().top;
            }
          }
          // Adjust elemPosition based on preview settings
          if(checkIfPreview && checkIfPreview != ''){
            if(this.service.preview.viewport === "web"){
              elemPosition =
                  elemPosition -
                  scrollTargetElement.getBoundingClientRect().top +
                  scrollTargetElement.scrollTop -
                  (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
            }
            else {
              scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
              elemPosition =
                  elemPosition -
                  scrollTargetElement.getBoundingClientRect().top +
                  scrollTargetElement.scrollTop;
            }
          } 
          else {
              elemPosition =
                  elemPosition -
                  scrollTargetElement.getBoundingClientRect().top +
                  scrollTargetElement.scrollTop;
          }
          scrollTargetElement.scrollTo({
            top: elemPosition - window.innerHeight / 3,
            behavior: 'smooth', 
          });
      }else if (this.questions.isMatrixQuestion != undefined && MatrixelemPosition !== null) {        
          let matrixCurrentElementMtrxELe = event.closest('.matrix-mobile-subQ_' + this.group.Matrix_id) as HTMLElement;
          if (matrixCurrentElementMtrxELe) {
            // Get all sibling elements after the current element
            const allSiblingsMtrxEle = Array.from(matrixCurrentElementMtrxELe.parentElement?.children || []) as HTMLElement[];
            const nextMatrixElementsMtrxEle = allSiblingsMtrxEle
              .slice(allSiblingsMtrxEle.indexOf(matrixCurrentElementMtrxELe) + 1)
              .filter((sibling) => sibling.matches('.matrix-mobile-subQ_' + this.group.Matrix_id) && sibling.querySelector('.question-data') !== null); // Filter by selector and `.question-data`

            // Get the position of the first matching element
            if (nextMatrixElementsMtrxEle.length > 0) {
              MatrixelemPosition = nextMatrixElementsMtrxEle[0].getBoundingClientRect().top;
            }
          }

          
          if(checkIfPreview && checkIfPreview != ''){
            if(this.service.preview.viewport === "web"){
              MatrixelemPosition =
                  MatrixelemPosition -
                  scrollTargetElement.getBoundingClientRect().top +
                  scrollTargetElement.scrollTop -
                  (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
            }
            else {
              scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
              MatrixelemPosition =
                MatrixelemPosition -
                scrollTargetElement.getBoundingClientRect().top +
                scrollTargetElement.scrollTop;
            }
          } else {
            MatrixelemPosition =
                MatrixelemPosition -
                scrollTargetElement.getBoundingClientRect().top +
                scrollTargetElement.scrollTop;
          }
  
          scrollTargetElement.scrollTo({
            top: MatrixelemPosition - window.innerHeight / 3,
            behavior: 'smooth',
          });
      }else if (this.questions.isMatrixQuestion != undefined && MatrixelemPosition1 !== null) {
         // Find the closest `.matrix-mobile-subQ-cont` element
          let matrixContCurrentElementM1 = event.closest('.matrix-mobile-subQ-cont') as HTMLElement;
          if (matrixContCurrentElementM1) {
            // Get all sibling elements after the current element
            const allSiblingsMtrxCOntM1 = Array.from(matrixContCurrentElementM1.parentElement?.children || []) as HTMLElement[];
            const nextMatrixContElementsM1 = allSiblingsMtrxCOntM1
              .slice(allSiblingsMtrxCOntM1.indexOf(matrixContCurrentElementM1) + 1) // Get all siblings after the current element
              .filter((sibling) => sibling.matches('.matrix-mobile-subQ-cont') && sibling.querySelector('.question-data') !== null); // Filter by selector and `.question-data`

            // Get the position of the first matching element
            if (nextMatrixContElementsM1.length > 0) {
              MatrixelemPosition1 = nextMatrixContElementsM1[0].getBoundingClientRect().top;
            }
          }

         if(checkIfPreview && checkIfPreview != ''){
            if(this.service.preview.viewport === "web"){
              MatrixelemPosition1 =
                  MatrixelemPosition1 -
                  scrollTargetElement.getBoundingClientRect().top +
                  scrollTargetElement.scrollTop -
                  (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
            }
            else {
              scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
              MatrixelemPosition1 =
                MatrixelemPosition1 -
                scrollTargetElement.getBoundingClientRect().top +
                scrollTargetElement.scrollTop;
            }
          } else {
            MatrixelemPosition1 =
                MatrixelemPosition1 -
                scrollTargetElement.getBoundingClientRect().top +
                scrollTargetElement.scrollTop;
          }
          scrollTargetElement.scrollTo({
            top: MatrixelemPosition1 - window.innerHeight / 3,
            behavior: 'smooth',
          });
      }else if (nextbtnLength > 0) {

          let activeQuestionForNBL = event.closest('.active-ques') as HTMLElement;

          if (activeQuestionForNBL) {
            // Get all sibling elements after the current element
            const allSiblingsForNBL = Array.from(activeQuestionForNBL.parentElement?.children || []) as HTMLElement[];
            const nextInactiveQuestionsForNBL = allSiblingsForNBL
              .slice(allSiblingsForNBL.indexOf(activeQuestionForNBL) + 1) // Get all siblings after the current element
              .filter((sibling) => sibling.matches('.inactive-ques') && sibling.querySelector('.question-data') !== null); // Filter by selector and `.question-data`
          
            // Get the position of the first matching element
            if (nextInactiveQuestionsForNBL.length > 0) {
              elemPosition = nextInactiveQuestionsForNBL[0].getBoundingClientRect().top;
            }
          }
         
          if(checkIfPreview && checkIfPreview != ''){
            if(this.service.preview.viewport === "web"){
              elemPosition =
                elemPosition -
                scrollTargetElement.getBoundingClientRect().top +
                scrollTargetElement.scrollTop -
                (document.querySelector('.toolbar') as HTMLElement)?.clientHeight!;
            }
            else {
              scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
              elemPosition =
                elemPosition -
                scrollTargetElement.getBoundingClientRect().top +
                scrollTargetElement.scrollTop;
            }
          } else {
            elemPosition =
              elemPosition -
              scrollTargetElement.getBoundingClientRect().top +
              scrollTargetElement.scrollTop;
          }
          scrollTargetElement.scrollTo({
            top: elemPosition - window.innerHeight / 3,
            behavior: 'smooth', // Replaces jQuery's animate for smooth scrolling
          });
      }else{

          if(checkIfPreview && checkIfPreview != ''){
            if(this.service.preview.viewport === "web"){
              scrollTargetElement = document.getElementById('bodyScroll') as HTMLElement;
            }
            else {
              scrollTargetElement = document.querySelector('.app-participation') as HTMLElement;
            }
          } 
          const tblPageFooter = document.querySelector('.tblPageFooter') as HTMLElement;
          if (tblPageFooter && scrollTargetElement) {
            const scrollVal =
              tblPageFooter.getBoundingClientRect().top +
              scrollTargetElement.scrollTop;

              scrollTargetElement.scrollTo({
                top: scrollVal,
                behavior: 'smooth', 
              });
          }
        }
    } else {
      this.service.gotoNextQuestion(question, event);
    }
  }


  clickEventHandle(answer: Answers) {
    if (answer.selectdId == 0) {
      this.SelectedValue(answer);
    } else {
      this.ClickEventHandling(answer);
    }
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event.target);
  }

  getAnswerPipeMessage(): string {
    return this.service.getAnswerPipeMessage();
  }
}
